import * as React from "react";
import { cn } from "../../lib/utils";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
};

export function Button({ className, variant = "primary", ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center rounded-full px-5 py-3 text-sm font-black transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:pointer-events-none disabled:opacity-50",
        variant === "primary" && "bg-pink text-white shadow-sm hover:bg-[#C22670]",
        variant === "secondary" && "border border-black/10 bg-white text-text shadow-sm hover:border-pink/70 hover:bg-pink/5",
        variant === "ghost" && "text-muted hover:text-text",
        className,
      )}
      {...props}
    />
  );
}

